import {Pipe, PipeTransform} from '@angular/core';
import {UserClockInDto} from '../../../Models/Rrhh/Clock-In/clock-in-list.interface';

@Pipe({
  name: 'clockIn',
  standalone: false
})
export class ClockInPipe implements PipeTransform {

  transform(items: UserClockInDto[], filter: { id_user?: number }): UserClockInDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.id_user) {
      items = items.filter((item) => item.id_usuario == filter.id_user);
    }

    return items;

  }

}
